export const isRouteAllowed = (url: string, notAllowedRoutes: string[]) => {
  for (const allowedRoute of notAllowedRoutes) {
    if (url.match(allowedRoute)) {
      return false;
    }
  }
  return true;
};
